<div>
  <form aria-label="upload-documents-panel" [formGroup]="form">
    @if (!limitReached) {
      <div class="grid grid-cols-12 gap-4 items-start">
        <div class="flex col-span-12 xl:col-span-6">
          <label class="font-semibold whitespace-nowrap" for="document-type">
            Document Types:
          </label>
          <div class="document-type">
            <p-multiSelect
              appendTo="body"
              class="p-0"
              placeholder="Select"
              display="chip"
              formControlName="docTypes"
              id="document-type"
              [displaySelectedLabel]="false"
              [filter]="false"
              [optionDisabled]="setSelectionAbility"
              [options]="documentTypes"
              [selectionLimit]="selectionLimit"
            >
              <ng-template let-item pTemplate="item">
                @if (item === 'NOMNC Rescind') {
                  <div>
                    {{ item }}
                    <i
                      class="pi pi-info-circle"
                      pTooltip="Selecting NOMNC Rescind excludes the possibility of choosing any other document type"
                      tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size"
                    ></i>
                  </div>
                } @else {
                  {{ item }}
                }
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
        <div class="flex grow col-span-12 xl:col">
          <label class="pr-2 py-2 font-semibold" for="description">
            Description:
          </label>
          <div class="document-type">
            <div>
              <input
                class="document-type"
                formControlName="description"
                id="description"
                maxlength="40"
                pInputText
                type="text"
              />
              <span class="block text-right"
              >{{
                  form?.get("description").value
                    ? form.get("description").value.length
                    : 0
                }}
                / 40</span
              >
            </div>
            <app-errors-messages [control]="description"></app-errors-messages>
          </div>
        </div>

        @if (form.get('docTypes').value?.length > 0) {
          <div>
            <button
              severity="secondary"
              class="mt-2"
              icon="pi pi-paperclip"
              label="Attach file"
              pButton
              type="button"
              [disabled]="isDisabled"
              (click)="onClick()"
            ></button>
          </div>
        }
      </div>
    } @else {
      <p-message
        severity="warn"
        icon="pi pi-exclamation-triangle"
        data-test-id="limit-Reached-Message"
      >
        <p class="font-semibold">Warning</p>
        <p>{{ limitReachedMessageText }}</p>
      </p-message>
    }

    @if (uploadedFiles.length > 0) {
      <div>
        <p-table responsiveLayout="scroll" [value]="uploadedFiles">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 15rem">File Name</th>
              <th style="width: 15rem">Document Type</th>
              <th style="width: 9rem">Description</th>
              @if (!isExternal) {
                <th style="width: 9rem">
                  Date/Time Request Received
                </th>
              }
              <th style="width: 3rem">File Size</th>
              <th style="width: 7rem">&nbsp;</th>
            </tr>
          </ng-template>
          <ng-template let-file let-ri="rowIndex" pTemplate="body">
            <tr>
              <td style="width: 15rem">
                    <span tooltipPosition="bottom" [pTooltip]="file.documentFileName">
                      {{ file.documentFileName }}
                    </span>
              </td>
              <td style="max-width: 17rem">
                    <span
                      class="truncate"
                      tooltipStyleClass="tooltip-xl-size"
                      [pTooltip]="file.documentTypes && file.documentTypes.join(', ')"
                    >
                      {{ file.documentTypes && file.documentTypes.join(", ") }}
                    </span>
              </td>
              <td style="width: 11rem">
                <div class="p-text-break-word">
                  {{ file.description }}
                </div>
              </td>
              @if (!isExternal) {
                <td style="width: 11rem">
                  <div class="p-text-break-word">
                    {{ file.dateTimeFaxReceived | date : "MM/dd/yyyy hh:mm:ss a" }}
                  </div>
                </td>
              }
              <td style="width: 3rem">{{ file.fileMetaData.size }} Bytes</td>
              <td class="text-right" style="width: 7rem">
                <button
                  class="p-button-text"
                  icon="pi pi-trash"
                  pButton
                  (click)="removeItem(ri)"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
    <div class="upload-btn-wrapper">
      <input
        #inputFile
        name="myfile"
        type="file"
        [accept]="filesAcceptableExtensions"
        [disabled]="isDisabled"
        [multiple]="multiple"
        (change)="onFileSelect($event)"
      />
    </div>
  </form>
</div>

<mnc-documents-shared-toast/>
